import TabsPage from "./TabsPage";

import Table from "components/Table";
import ToggleButtons from "components/ToggleButtons";
import ButtonIcon from "components/ButtonIcon";

import { ReactComponent as ArrowBig } from 'icons/components/arrowBig.svg';

export default class Visits extends TabsPage {
    constructor(props) {
        super(props);

        this.tableMap = {
            beginDate: {
                label: "client.date",
                type: "date",
            },
            times: {
                label: "main.time",
                type: "timePeriod",
                keys: ["beginDate", "endDate"],
                sortKey: "endDate"
            },
            doctorId: {
                label: "client.doctor",
                type: "doctor",
            },
            reasonId: {
                label: "main.reason",
                callback: this.reasonCell.bind(this),
            },
            domainId: {
                label: "login.clinic",
                type: "select",
                store: "clinics",
                nameKey: "name",
            },
            comment: {
                label: "client.comment",
            },
        };

        const { subTab } = this._helper.getUrlOptions();
        const savedSubTab = globalThis.savedProps.clientVisitsTab;
        const subTabValue = subTab || savedSubTab;

        if (subTab)
            globalThis.savedProps.clientVisitsTab = subTab;
        else if (savedSubTab)
            this.needSetPageProps = true;

        this.state = {
            ...this.state,
            sort: "-beginDate",
            items: [],
            isCreateMode: subTabValue !== "history",
        };
    }

    rowFormat({ status }, cl) {
        if (status === "WI_CANCELED" || status === "WI_REPLACED")
            cl.push("disabled");

        return cl;
    }

    rowClick({ beginDate, domainId }) {
        const date = this._helper.date.toDateServerStr(beginDate);

        this._helper.openPage("appointment", { date, domainId });
    }

    reasonCell(value, map, { status, replaceReasonComment, replaceReasonId }) {
        const start = this._helper.getReason(value);

        if (status === "WI_CANCELED") {
            const replaceText = replaceReasonComment || this._helper.getReplaceReason(replaceReasonId);
            return `${start} / ${replaceText}`;
        }

        return start;
    }

    componentDidMount() {
        this.refresh();

        if (this.needSetPageProps) {
            const subTab = globalThis.savedProps.clientVisitsTab;
            this.props.setPageTab(null, { subTab });
        }
    }

    onSortChange(sort) {
        this.state.sort = sort;
        this.refresh();
    }

    onModeChange(mode) {
        this.state.isCreateMode = mode;

        const subTab = mode ? "planning" : "history";

        this.props.setPageTab(null, { subTab });
        globalThis.savedProps.clientVisitsTab = subTab;

        this.refresh();
    }

    refresh() {
        this.getData();
    }

    async getData() {
        this._helper.showLoading();

        const { id } = this.props.info;
        const { sort, isCreateMode } = this.state;
        const resp = await this._request.visits.getForClient(id, sort, isCreateMode);
        const items = resp?.data || [];

        this.setState({ items });

        this._helper.hideLoading();
    }

    print(isCreateMode) {
        const { id } = this.props.info;
        const name = isCreateMode ? "Visits_planning" : "Visits_history";

        this.printShow(name, {
            clientId: id + ""
        });
    }

    renderInfo(infoOpened) {
        const { firstVisit, lastVisit, completedVisits, recommendationCount, latenessVisits, absenceVisits } = this.props.info;
        const cl = infoOpened ? " active" : "";
        const arrowCl = infoOpened ? "rotate90" : "rotate90m";

        let firstVisitInfo = "-";
        if (firstVisit)
            firstVisitInfo = `${this._helper.string.formatFullName(this.props.getDoctorById(firstVisit.doctorId), "short")}, ${this._helper.date.toStr(firstVisit.beginDate, "DD.MM.YYYY")}`;

        let lastVisitInfo = "-";
        if (lastVisit)
            lastVisitInfo = `${this._helper.string.formatFullName(this.props.getDoctorById(lastVisit.doctorId), "short")}, ${this._helper.date.toStr(lastVisit.endDate, "DD.MM.YYYY")}`;

        return (
            <div className={`opener flex col gap16${cl}`} onClick={this.toggleState.bind(this, "infoOpened")}>
                <div className="flex gap16 centerV hand">
                    <ArrowBig className={arrowCl} />
                    {this.renderRow("client.firstVisit", <div className="hand">{firstVisitInfo}</div>, "Blue")}
                </div>
                {infoOpened && (
                    <div className="visitInfo flex col gap8">
                        {this.renderRow("client.lastVisit", <div className="hand">{lastVisitInfo}</div>, "Blue")}
                        {this.renderRow("report.totalVisits", <div>{completedVisits ? completedVisits : this.tr("client.missing")}</div>)}
                        {this.renderRow("client.recommendations", <div>{recommendationCount ? recommendationCount : this.tr("client.missing")}</div>)}
                        {this.renderRow("client.late", <div>{latenessVisits ? latenessVisits : this.tr("client.missing")}</div>)}
                        {this.renderRow("client.absences", <div className="hand">{absenceVisits ? absenceVisits : this.tr("client.missing")}</div>, "Blue")}
                    </div>
                )}
            </div>
        );
    }

    renderContent() {
        const { sort, items, isCreateMode, infoOpened } = this.state;

        return (
            <>
                {this.renderInfo(infoOpened)}
                <div className="actions flex between">
                    <ToggleButtons
                        active={isCreateMode}
                        labels={["app.allApps", "app.visitHistory"]}
                        values={[true, false]}
                        value={isCreateMode}
                        onChange={this.onModeChange.bind(this)}
                    />
                    <div>
                        <ButtonIcon name="print" onClick={this.print.bind(this, isCreateMode)} />
                    </div>
                </div>
                <Table
                    map={this.tableMap}
                    items={items}
                    sort={sort}
                    rowProps={{
                        format: this.rowFormat.bind(this),
                        click: this.rowClick.bind(this),
                    }}
                    onSortChange={this.onSortChange.bind(this)}
                />
            </>
        );
    }
}
